import React from 'react';
import { useFetchHelpDoc } from '../Hooks/common/useFetchHelpDoc';
import Spinner from '../common/Spinner';


const HelpPdf = () => {

    const doc = "help";
    const helpDoc = useFetchHelpDoc(doc);
    const helpData = helpDoc?.data;

    return (
        <div className="grid min-h-screen place-items-center">
            {helpDoc?.isLoading && (
                <Spinner text="Loading Data... Pls wait" />
            )}
            {helpDoc?.isError && (
                <p className="text-red-500">Problem with query. Please try again later.</p>
            )}
            {helpDoc?.isSuccess && helpData ? (
                <iframe className="w-full h-full"
                    src={helpData}
                    title={doc}
                    allowFullScreen={true} />
            ) : (
                !helpDoc?.isLoading && !helpDoc?.isError && (
                    <p className="text-red-500">No data available.</p>
                )
            )}
        </div>
    );
};

export default HelpPdf;